import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown as iconDown,
  faChevronUp as iconUp
} from '@fortawesome/free-solid-svg-icons';
import { Collapse } from 'reactstrap';
import React, { useState, JSX } from 'react';
import { ApiBookedItem, ApiFlightItem } from '@ibe/api';
import FlightInfo from '../Flight/FlightInfo';
import DateDisplay from '../../Components/UI/DateDisplay/DateDisplay';
import useTranslation from '../../Hooks/useTranslation';
import Keys from '../../../_Translations/generated/package-summary.en.t.json.keys';
import fallback from '../../../_Translations/generated/package-summary.en.t.json';
import FlightUtil from '../../../Utils/FlightUtil';
import { Price } from '../../Components/UI/Price/Price';

interface FlightInfoItemProps {
  flight: ApiFlightItem;
  bookedItem: ApiBookedItem;
}

const FlightInfoItem = (props: FlightInfoItemProps): JSX.Element => {
  const { t } = useTranslation('package-summary', fallback, Keys);

  const { flight, bookedItem } = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="card bg-transparent w-100">
      <div
        className="card-body"
        style={{ cursor: 'pointer' }}
        onClick={(): void => setIsOpen(!isOpen)}
      >
        <div className="align-items-center justify-content-between">
          <div>
            {flight.segment.map(segment => {
              return (
                <div key={segment.id}>
                  <div>
                    <strong>{`${t(Keys.flight)} ${segment.origin.code} - ${
                      segment.destination.code
                    }`}</strong>
                  </div>
                  <div>
                    <span>
                      <DateDisplay utc format="HH:mm" date={segment.departure} />
                      {' - '}
                      <DateDisplay utc format="HH:mm" date={segment.arrival} />
                      {segment.dateDeviation > 0 && <sup>+{segment.dateDeviation}</sup>}
                    </span>
                  </div>
                  <div>{`${FlightUtil.getFlightDuration(segment.flightDuration)}, ${
                    segment.legs.length - 1
                  } ${t(Keys.stops)}`}</div>
                  <br />
                </div>
              );
            })}
          </div>
          {bookedItem.price && (
            <div className="d-flex align-items-center justify-content-end">
              <Price price={bookedItem.price} />
              <Icon className="ml-1" icon={isOpen ? iconUp : iconDown} />
            </div>
          )}
        </div>
      </div>

      <Collapse isOpen={isOpen}>
        <div className="card-footer pt-3">
          <FlightInfo flight={flight} />
        </div>
      </Collapse>
    </div>
  );
};
export default FlightInfoItem;
